@let menuItems = menuItems$ | async;
@let isMobile = isMobile$ | async;

@if (menuItems) {
	<p-menubar [dt]="menubarHeaderDesignToken" [breakpoint]="breakpoint">
		<ng-template #start>
			<a routerLink="/">
				<div class="title">{{ title + ((isStaging$ | async) ? ' - Staging' : '') }}</div>
			</a>
		</ng-template>
		<ng-template #end>
			<div class="end-items">
				@if (externalModeService.canToggleExternalMode$ | async) {
					<p-button (onClick)="toggleExternalMode()" size="large" [outlined]="true">
						<div style="font-size: 16px; padding: 0 8px; width: 160px">
							External mode:
							<b>{{ (externalModeService.isExternalMode$ | async) ? 'ON' : 'OFF' }}</b>
						</div>
					</p-button>
				}
				@if (isMobile) {
					<a [href]="homeUrl">
						<div>
							<img class="traton-logo-mobile" alt="Traton logo" src="assets/logos/svg/TRATON_Super_sign_RGB_White.svg" />
						</div>
					</a>
				} @else {
					<a [href]="homeUrl">
						<div>
							<img class="traton-logo" alt="Traton logo" src="assets/logos/svg/TRATON_Logo_RGB_white.svg" />
						</div>
					</a>
				}
				<p-button raised="true" severity="secondary" variant="outlined" size="small" icon="pi pi-bars" (onClick)="menu.toggle($event)"></p-button>
			</div>
			<p-tieredmenu #menu [dt]="menuDesignToken" popup="true" [model]="menuItems" appendTo="body" breakpoint="0">
				@if (authService.userData$ | async; as userData) {
					<p-drawer [dt]="drawerDesignToken" header="User details" [(visible)]="showUserDetails" modal="true" [position]="isMobile ? 'full' : 'right'" closable="true">
						@defer (when showUserDetails) {
							@if (functionalGroups$ | async; as functionalGroups) {
								<div class="table-container">
									<div>
										<table>
											<tr>
												<td class="table-row">Name</td>
												<td class="table-row">{{ userData?.firstName }} {{ userData?.lastName }}</td>
											</tr>
											<tr>
												<td class="table-row">Company</td>
												<td class="table-row">{{ userData?.companyName }}</td>
											</tr>
											<tr>
												<td class="table-row">Username</td>
												<td class="table-row">{{ userData?.userName }}</td>
											</tr>
										</table>
									</div>
									@if (functionalGroups.length !== 0) {
										<div class="table-title">
											<h4><b>Functional groups</b></h4>
										</div>
										<div>
											<table>
												@for (functionalGroup of functionalGroups; track $index) {
													<tr>
														<td class="table-row">{{ functionalGroup.name }}</td>
													</tr>
												}
											</table>
										</div>
									}
								</div>
							} @else {
								<div style="align-items: center; display: flex">
									<p-progressSpinner></p-progressSpinner>
								</div>
							}
						}
					</p-drawer>
				}
			</p-tieredmenu>
		</ng-template>
	</p-menubar>
}
